import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import HpRewardsBadge from '@hpstellar/core/HpRewardBadge/HpRewardBadge.js'
import Link from '@hpstellar/core/Link/Link.js'

import '../css/loyalty-badge-v2.less';

const LoyaltyBadge = ({ multiplier, userSeg, ...rest }) => {
    if (userSeg === 'CG_gs' && multiplier && multiplier !== '0') {
        const tooltipContent = {
            customContent: (<div className='loyalty-tooltip'>
                <h2>HP REWARDS</h2>
                <p>
                    HP Rewards is a loyalty program where users earn HP Rewards points by buying eligible HP Products.
                </p>
                <Link
                    href={`${process.env.BASENAME}/LoadLoyaltyLandingPageCmd?catalogId=10051&userTyp=G&storeId=10151`}
                    color='primary'
                    target='_blank'
                    variation="primary"
                    size='small'
                    dense
                >
                    Learn more
                </Link>
            </div>)
        };
        return (<HpRewardsBadge
            message={`Earn ${multiplier}X HP Rewards Points`}
            tooltipContent={tooltipContent}
            {...rest}
        />)
    }
    return null;
};

LoyaltyBadge.defaultProps = {
    type: 'pdp'
}

LoyaltyBadge.propTypes = {
    /*hp reward multiplier from product attributes*/
    multiplier: PropTypes.string.isRequired,
    /*component type*/
    type: PropTypes.oneOf(['pdp', 'productCard'])
}

const mapStateToProps = (state) => {
    const { userData = {} } = state;
    const { profileData = {} } = userData;
    const { personData = {} } = profileData;

    return {
        userSeg: personData.custSeg
    };
};


export default connect(mapStateToProps, undefined)(LoyaltyBadge);

